module.exports = __webpack_public_path__ + "static/newsletter-nov-2019-1e3db4dd8b2c5b60d9de08db4ec237b5.png";